import { createApiRequest } from "../common";
import { AcceptOrgInviteRequestContent, AcceptOrgInviteResponseContent } from '@equaliq/api-model';

export const acceptOrgInviteApi = async (request: AcceptOrgInviteRequestContent): Promise<AcceptOrgInviteResponseContent> => {
  const apiRequest = createApiRequest<AcceptOrgInviteResponseContent>('post', '/orgs/invites/accept');
  return apiRequest(request);
};